import React from 'react';

export const HowItWorksSection: React.FC = () => {
  const steps = [
    {
      number: '1',
      title: 'El proveedor se une',
      description: 'Negocios, profesionales y apps se registran en BiviLinks para ofrecer sus servicios: car wash, limpieza, mantenimiento, entregas, jardinería, electricidad, fontanería, estilismo, venta de productos, etc. Incluso quienes no tienen app propia pueden participar.',
      icon: 'ri-store-2-line',
    },
    {
      number: '2',
      title: 'El referidor se registra',
      description: 'Cualquier persona puede unirse como referidor y obtener un enlace único (URL personal) que podrá compartir libremente en redes sociales, WhatsApp, correo o de forma directa.',
      icon: 'ri-user-add-line',
    },
    {
      number: '3',
      title: 'El usuario contrata o compra',
      description: 'Cuando alguien accede a través de ese enlace, descarga la aplicación y contrata un servicio o realiza una compra, el sistema reconoce al referidor.',
      icon: 'ri-shopping-cart-line',
    },
    {
      number: '4',
      title: 'Se genera la venta',
      description: 'El proveedor recibe el pago de su servicio o producto, y la transacción queda registrada dentro de la plataforma.',
      icon: 'ri-money-dollar-circle-line',
    },
    {
      number: '5',
      title: 'Se paga la comisión',
      description: 'De forma automática, BiviLinks acredita una comisión al referidor que generó esa venta. El proceso es digital, transparente y verificable dentro del panel de usuario.',
      icon: 'ri-wallet-line',
    },
  ];

  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
            Cómo Funciona
          </h2>
          <div className="w-24 h-1 bg-primary-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un proceso simple y transparente en 5 pasos
          </p>
        </div>

        <div className="relative">
          {/* Línea conectora vertical en móvil, horizontal en desktop */}
          <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-primary-200 via-primary-400 to-primary-200"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-4">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="relative z-10 w-20 h-20 bg-primary-600 rounded-full flex items-center justify-center mb-6 shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  
                  <div className="absolute top-8 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-white border-4 border-primary-600 rounded-full flex items-center justify-center font-bold text-primary-600 text-xl z-20">
                    {step.number}
                  </div>
                  
                  <h3 className="text-lg font-bold text-primary-800 mb-3 mt-4">
                    {step.title}
                  </h3>
                  
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
                
                {/* Flecha conectora solo en desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-10 -right-2 z-0">
                    <i className="ri-arrow-right-line text-3xl text-primary-400"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
